/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBritaxHoverModuleViewProps } from './britax-hover-module';

export default (props: IBritaxHoverModuleViewProps) => {
    return <div>{props.hoveredCard}</div>;
};
